module.exports = __webpack_public_path__ + "static/media/Asset.2894b082.png";